const Envelope = (props) => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M17.1918 8.74314L0.853915 0.55173C0.787509 0.518526 0.711337 0.510714 0.639071 0.528292C0.473055 0.569308 0.36954 0.737276 0.410555 0.905245L2.09415 7.78415C2.11954 7.88767 2.19571 7.97165 2.29727 8.00485L5.18204 8.99509L2.29923 9.98532C2.19766 10.0205 2.12149 10.1025 2.09806 10.206L0.410555 17.0947C0.392977 17.167 0.40079 17.2431 0.433993 17.3076C0.510165 17.4619 0.697665 17.5244 0.853915 17.4482L17.1918 9.30368C17.2524 9.27439 17.3012 9.2236 17.3324 9.16501C17.4086 9.00876 17.3461 8.82126 17.1918 8.74314ZM2.33634 15.1377L3.31876 11.122L9.08438 9.14353C9.12931 9.1279 9.16642 9.09275 9.18204 9.04587C9.20938 8.96384 9.16642 8.87595 9.08438 8.84665L3.31876 6.87009L2.34024 2.87009L14.6059 9.02048L2.33634 15.1377Z'
      fill='#C2C2C2'
    />
  </svg>
);

export default Envelope;
